export { SolicitacaoExames } from './SolicitacaoExames'
